<ambita-cadastre-report-cultural-heritages>
  <div class="ambita-cadastre-report__sub-section--collapsible
            { ambita-cadastre-report__sub-section--collapsed: collapseCulturalHeritages }"
    each="{ heritage in opts.heritages }">
    <header class="ambita-cadastre-report__sub-section-header" onclick="{ collapse }">
      <i class="ambita-cadastre-report__sub-section-arrow"></i>
      <span class="ambita-cadastre-report__sub-section-title">
        { heritage.siteDating.text } { heritage.objectName }
      </span>
    </header>
    <div class="ambita-cadastre-report__sub-section-content ambita-cadastre-report-clearfix">
      <ul class="ambita-cadastre-report__document-output ambita-report-ul">
        <li>
          <span class="ambita-cadastre-report__document-output-title">
            { i18n.propertyLookup.sefrakIdent }
          </span>
          <span class="ambita-cadastre-report__document-output-value">
            { heritage.ident.municipalityNumber }
            { heritage.ident.registrationDistrictNumber }
            { heritage.ident.houseSerialNumber }
          </span>
        </li>
        <li>
          <span class="ambita-cadastre-report__document-output-title">
            { i18n.propertyLookup.sefrakObjectName }
          </span>
          <span class="ambita-cadastre-report__document-output-value">
            { heritage.objectName }
          </span>
        </li>
        <li>
          <span class="ambita-cadastre-report__document-output-title">
            { i18n.propertyLookup.sefrakSiteDating }
          </span>
          <span class="ambita-cadastre-report__document-output-value">
            { heritage.siteDating.text }
          </span>
        </li>
        <li>
          <span class="ambita-cadastre-report__document-output-title">
            { i18n.propertyLookup.sefrakOriginalFunction }
          </span>
          <span class="ambita-cadastre-report__document-output-value">
            { heritage.originalFunction }
          </span>
        </li>
        <li>
          <span class="ambita-cadastre-report__document-output-title">
            { i18n.propertyLookup.sefrakCurrentFunction }
          </span>
          <span class="ambita-cadastre-report__document-output-value">
            { heritage.currentFunction }
          </span>
        </li>
        <li>
          <span class="ambita-cadastre-report__document-output-title">
            { i18n.propertyLookup.sefrakExtension }
          </span>
          <span class="ambita-cadastre-report__document-output-value">
            { heritage.extension }
          </span>
        </li>
        <li if="{ building.coordinates }">
          <a class="ambita-report-link"
            href="{ url_sefrak_map }&mappin={ building.coordinates[0] }|{ building.coordinates[1] }&extent={ building.coordinates[0] }|{ building.coordinates[1] }|{ building.coordinates[0] }|{ building.coordinates[1] }"
            target="_blank">
            { i18n.propertyLookup.showInMap }
          </a>
        </li>
      </ul>
    </div>
  </div>

  <script>
    import { init } from '../sectionController';
    import * as cadastreReportConstants from '../../../../constants/cadastreReport';

    init(this);

    this.url_sefrak_map = cadastreReportConstants.constants.URL_SEFRAK_MAP;

    this.on('update', function () {
      this.collapseCulturalHeritages = this.shouldCollapse(this.opts.heritages);
    });
  </script>
</ambita-cadastre-report-cultural-heritages>
